import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news21_1 from "../../images/news/news21_1.jpg";
import news21_2 from "../../images/news/news21_2.jpg";
import news21_3 from "../../images/news/news21_3.jpg";
import news21_4 from "../../images/news/news21_4.jpg";
import news21_5 from "../../images/news/news21_5.jpg";
import news21_6 from "../../images/news/news21_6.jpg";
import news21_7 from "../../images/news/news21_7.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news21 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News21_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News21_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News21_LinkHome")}</Link>
                                </li>
                                <li>{t("News21_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News21_Content_H")}</h1>

                                            
                                            {/* P1 */}
                                            <ReactMarkdown>{t("News21_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_1}
                                                    alt={t("News21_IMG1_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News21_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News21_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_2}
                                                    alt={t("News21_IMG2_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News21_IMG2_DESC")}
                                                </div>
                                            </div>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_3}
                                                    alt={t("News21_IMG3_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News21_IMG3_DESC")}
                                                </div>
                                            </div>

                                            
                                            {/* P3 */}
                                            <ReactMarkdown>{t("News21_P3_MD")}</ReactMarkdown>


                                            {/* IMG 4 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_4}
                                                    alt={t("News21_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News21_IMG4_DESC")}
                                                </div>
                                            </div>

                                            
                                            {/* P4 */}
                                            <ReactMarkdown>{t("News21_P4_MD")}</ReactMarkdown>

                                            {/* IMG 5 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_5}
                                                    alt={t("News21_IMG5_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News21_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News21_P5_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_6}
                                                    alt={t("News21_IMG6_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News21_IMG6_DESC")}
                                                </div>
                                            </div>

                                            
                                            {/* P6 */}
                                            <ReactMarkdown>{t("News21_P6_MD")}</ReactMarkdown>

                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "21px 0" }}>
                                                <img
                                                    src={news21_7}
                                                    alt={t("News21_IMG7_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News21_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News21_P7_MD")}</ReactMarkdown>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                
            </>
            
        );
    }
}

export default news21 = withTranslation()(news21);
